import * as React from 'react';
export const BNSvg = React.forwardRef(function BNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 7V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1H0a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3h-1zM1 9v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1h1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9h1z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'm0 3.5 16 3v3l-16-3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'm15 6.313 1 .187v3l-1-.188v-3ZM1 3.688v3L0 6.5v-3l1 .188Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'm0 6.5 16 3v3l-16-3z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z',
      }),
    ),
  );
});
BNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BN = {
  category: 'flag',
  colorable: false,
  name: 'BN',
  svg: BNSvg,
};
